import { useAuth0 } from '@auth0/auth0-react';
import { IS_PLG_PROD } from 'constants/Global.constants';

import { useIsFeatureOn } from './useFeatureSwitch';

export function useIsPlgProd(): boolean {
  const { features } = useIsFeatureOn();
  const { user } = useAuth0();

  if (IS_PLG_PROD) {
    return true;
  }

  const mimicFeature = features?.find(f => f.name === 'mimic_plg_prod');
  if (!mimicFeature?.enabled) {
    return false;
  }

  // Only allow mimic_plg_prod if there's a whitelist configured
  // If enabled globally without a whitelist, treat it as an error and ignore it
  const hasWhitelist =
    mimicFeature.whitelist?.users && mimicFeature.whitelist.users.length > 0;

  if (!hasWhitelist) {
    return false;
  }

  return !!(user?.email && mimicFeature.whitelist?.users?.includes(user.email));
}
